import api from 'api'

export type BreakAction = 'take' | 'waive' | 'missed'

export type RecordShiftWorkBreakRequest = {
  event: BreakAction
  startTime?: string
  endTime?: string
  reason?: string
}

export const recordShiftWorkBreak = async ({
  workId,
  breakNumber,
  ...body
}: RecordShiftWorkBreakRequest & {
  workId: number
  breakNumber: number
}): Promise<void> => {
  await api.put(`/admin/work/${workId}/break/${breakNumber}`, body)
}
